// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
  aws_app_analytics: 'enable',
  aws_cognito_identity_pool_id: 'eu-central-1:ad5a06c1-0191-44b3-8bf7-a0da1c27f5a0',
  aws_cognito_region: 'eu-central-1',
  aws_mobile_analytics_app_id: 'c3154cd29ce541cb940898b759d7e290',
  aws_mobile_analytics_app_region: 'us-east-1',
  aws_project_id: 'ad69946d-57a9-4685-a143-c60b02a6641c',
  aws_project_name: 'MeetingDoctors_Groups_Uploads',
  aws_project_region: 'eu-central-1',
  aws_resource_name_prefix: 'meetingdoctorsgroups-mobilehub-300209103',
  aws_user_files: 'enable',
  aws_user_files_s3_bucket: 'meetingdoctorsgroups-userfiles-mobilehub-300209103',
  aws_user_files_s3_bucket_region: 'eu-central-1',
}

export default awsmobile
